import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone';
import LoadingSmall from "../../../components/LoadingSmall";
import Loading from "../../../components/Loading";
import axios from 'axios';
import Portal from "react-portal";
import FullScreenOverlay from "../../../components/FullScreenOverlay";
import SegmentsNew from "../../segments/SegmentsNew";
import OptionColumn from "../../../components/general/OptionColumn";
import SplitRows from '../../../components/general/SplitRow.js';

const validate = values => {
    const errors = {}

    if(!values.title) {
        errors.title = 'Required';
    }

    if(values.title) {
        if(values.title.length > 45) {
            errors.title = 'Title must be less than 45 characters';
        }
    }

    if(!values.message) {
        errors.message= 'Required';
    }

    if(values.message) {
        if(values.message.length > 100) {
            errors.message = 'Message must be less than 100 characters';
        }
    }

    if(!values.url) {
        errors.url = 'Required';
    }

    if(values.url) {
        if(!values.url.includes('https://') && !values.url.includes('http://')) {
            errors.url = 'Url must start with https:// or http://';
        }
    }

    if(!values.audience) {
        errors.audience = 'Required';
    }

    if(values.audience == 'select') {
        errors.audience = 'You must select an audience';
    }

    if(values.audience == '1') {
        if(values.segment == '0' || !values.segment) {
            errors.segment = 'You must select a segment';
        }
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, disabled,type, meta: { touched, error } }) => (

    <div className={`form-group ${touched && error ? 'has-danger':''}`}>
        <label className="form-control-label">{title}</label>
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type} disabled={disabled} autoComplete="off" />
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>

)

const checkbox = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className="checkbox-custom checkbox-primary">
        <input {...input} name={name} type={type} />
        <label>{title}</label>
    </div>
)

const radio = ({ input, name,className,placeholder, title, meta: { touched, error } }) => (
    <div className="radio-custom radio-primary">
        <input {...input} name={name} type="radio" />
        <label>{title}</label>
    </div>
)

const select = ({ input, options,name,className,disabled,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group ${touched && error ? 'has-danger':''}`}>
        <select name={name} disabled={disabled} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const renderDropzoneInput = (field) => {
    const files = field.input.value;
    return (
        <div>
            <Dropzone
                multiple={false}
                name={field.name}
                onDrop={( filesToUpload, e ) => field.input.onChange(filesToUpload)}
            >
                <div>Try dropping some files here, or click to select files to upload.</div>
            </Dropzone>
            {field.meta.touched &&
            field.meta.error &&
            <span className="error">{field.meta.error}</span>}
        </div>
    );
}

class PushMessageEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSaving:false,
            file:false,
            segments:[],
            isLoadingSegments:true,
            currentSegment:false,
            showDialog:false,
        }

        this.onOpenClick = this.onOpenClick.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.renderSegments = this.renderSegments.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }


    handleSave() {
        this.getSegments();
    }

    renderSegments() {
        let options=[];

        if(this.state.isLoadingSegments) {
            options.push({
                label:'Loading segments...',
                value:0
            })
        }

        if(this.state.segments.length > 0) {
            options.push({
                label:'Select a segment',
                value:0
            })
        }

        this.state.segments.map((segment,i) => {
            options.push({
                label:segment.name,
                value:segment.id,
            })
        });

        if(this.state.segments.length == 0) {
            options.push({
                label:'-- None --',
                value:0
            })
        }

        return options;
    }

    componentWillMount() {
        this.getSegments();
    }

    getSegments() {
        this.setState({
            isLoadingSegments:true,
        });
        axios.get('/segments?type=push').then(res => {
            this.setState({
                isLoadingSegments:false,
                segments:res.data
            });
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }

    onDrop(files) {
        if(files.length == 0) {
            return;
        }

        let file = files[0];

        if(!file.type.includes('image/')) {
            return;
        }

        this.setState({file:file});
        this.props.change('icon',file.preview);


        return;


    }

    onSubmit(data){
        this.setState({
            isSaving:true
        });

        let form = new FormData();

        if(this.state.file !== false) {
            form.append('file', this.state.file);
        }

        for(let i in data) {
            form.append(i,data[i]);
        }

        axios.post('/push',form)
            .then(res => {
                this.setState({isSaving:false});
                this.props.save(res);
            }).catch(err => {
            this.setState({isSaving:false});
        });
    }


    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>

                <OptionColumn title="Notification" description="Add title, message and a icon">
                    <div className="col-sm-7">
                        <Field component={renderField} type="text" name="title" placeholder="Crazy weekend!" title="Title" className="form-control" />
                        <Field component={renderField} type="text" name="message" placeholder="25% off this weekend" title="Message" className="form-control" />

                        <table>
                            <tbody>
                            <tr>
                                <td style={{textAlign:'center'}}>
                                    <img width={80} src={this.props.icon} /><br />
                                    <span style={{fontSize:'10px'}}>Recommended size: 192x192</span>
                                </td>
                                <td>
                                    <Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
                                        {
                                            this.state.isUploading ?
                                                <LoadingSmall />
                                                :
                                                <button type="button" onClick={this.onOpenClick} className="btn btn-dark">Change</button>
                                        }
                                    </Dropzone>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="col-sm-5">
                        <h5>Preview</h5>
                        <div style={{width:'400px',border:'1px solid #e4eaec'}}>
                            <div style={{float:'left'}}>
                                <img width={80} src={this.props.icon} />
                            </div>
                            <div style={{marginLeft:'80px',padding:'6px',borderLeft:'1px solid #e4eaec'}}>
                                <div style={{fontSize:'15px',whiteSpace:'nowrap',overflow:'hidden'}}>{this.props.title ? this.props.title:'Crazy weekend!'}</div>
                                <div style={{fontSize:'13px'}}>{this.props.message ? this.props.message:'25% off this weekend'}</div>
                                <div style={{marginTop:'8px',fontSize:'13px'}}>{this.props.subdomain}.crall.io</div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <br />
                        <span style={{fontSize:'12px'}}>Notifications will look different on each client depending on browser, operation system and device.</span>
                    </div>
                </OptionColumn>

                <SplitRows />

                <OptionColumn title="Target url" description="Url to open when user clicks the notification">
                    <Field component={renderField} type="text" name="url" placeholder="https://www.example.com" title="Url" className="form-control" />
                </OptionColumn>

                <SplitRows />

                <OptionColumn title="Audience" description="Send message to all or selected subscribers">
                    <div className={this.props.audience == 1 ? 'col-sm-6':'col-sm-12'}>
                        <Field component={select} name="audience" title={false} options={[
                            {
                                value:'select',
                                label:'Send to...'
                            },
                            {
                                value:0,
                                label:'Send to all subscribers'
                            },
                            {
                                value:1,
                                label:'Send to subscribers matching a segment'
                            }
                        ]} />
                    </div>
                    <div className="col-sm-6" style={{display:this.props.audience == 1 ? 'block':'none'}}>
                        {
                            this.props.enableSegment == '1' ?
                                <div>
                                    <div className="col-sm-8">
                                        <Field component={select} name="segment" disabled={this.state.isLoadingSegments} title={false} options={this.renderSegments()} />
                                    </div>
                                    <div className="col-sm-4">
                                        <button onClick={e => { e.stopPropagation(); this.setState({currentSegment:false,showDialog:true}) }} className="btn btn-block btn-dark">New segment</button>
                                    </div>
                                </div>:<div className="alert dark alert-danger">
                                    Segments isn't included in your package. Please upgrade to "Premium plus".
                                </div>
                        }

                    </div>
                </OptionColumn>

                <SplitRows />

                <OptionColumn title="Finish" description="Save notification and add to queue">
                    {
                        this.state.isSaving ? <LoadingSmall />:<button type="submit" className="btn btn-success btn-icon btn-block"><i className="icon fa-rocket"></i> Send notification</button>
                    }
                </OptionColumn>


                <Portal closeOnEsc onClose={e => {this.setState({currentSegment:false,showDialog:false})}} isOpened={this.state.showDialog}>
                    <FullScreenOverlay>
                        <SegmentsNew handleSave={this.handleSave} type="push" onClose={e => {this.setState({currentSegment:false,showDialog:false})}} segmentId={this.state.currentSegment} />
                    </FullScreenOverlay>
                </Portal>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});

const selector = formValueSelector('PushMessageEditor');

// Decorate the form component
PushMessageEditor = reduxForm({
    form: 'PushMessageEditor',
    validate,
})(PushMessageEditor);

PushMessageEditor = connect(
    state => ({
        title:selector(state, 'title'),
        message:selector(state, 'message'),
        icon:selector(state, 'icon'),
        audience:selector(state, 'audience'),
    })
)(PushMessageEditor)

export default PushMessageEditor;


// WEBPACK FOOTER //
// ./containers/push/forms/PushMessageEditor.js